import { render, staticRenderFns } from "./UserGroupCreate.vue?vue&type=template&id=766091d3&scoped=true"
import script from "./UserGroupCreate.vue?vue&type=script&lang=js"
export * from "./UserGroupCreate.vue?vue&type=script&lang=js"
import style0 from "./UserGroupCreate.vue?vue&type=style&index=0&id=766091d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766091d3",
  null
  
)

export default component.exports